module.exports = __webpack_public_path__ + "img/carrousel-arco-digi-5.d7836a73.png";